"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleMaps = void 0;
const loader_1 = require("./loader");
const helper_1 = require("../../core/library/helper");
const library_1 = require("../../core/library");
class GoogleMaps extends library_1.Library {
    constructor(googleMapsApiKey) {
        super('GoogleMaps', new loader_1.GoogleMapsLoader(googleMapsApiKey));
        return (0, helper_1.withLibraryLoadCheck)(this);
    }
}
exports.GoogleMaps = GoogleMaps;
//# sourceMappingURL=index.js.map